import React, { useState } from "react";
import "./PrivacySettings.css";

const PrivacySettings = ({ setMessage }) => {
  // Privacy settings state
  const [privacySettings, setPrivacySettings] = useState({
    publicProfile: true,
    showActivity: true,
    showLists: true
  });

  // Data export state
  const [exportType, setExportType] = useState("all");
  const [exportLoading, setExportLoading] = useState(false);

  // Handle privacy changes
  const handlePrivacyChange = (e) => {
    const { name, checked } = e.target;
    setPrivacySettings(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  // Handle privacy settings save
  const handleSavePrivacySettings = () => {
    // This would actually call the API to save the settings
    // For now, it's just a mock function
    setMessage({
      type: "success",
      text: "Privacy settings saved successfully!"
    });
    
    // Auto-clear message after 5 seconds
    setTimeout(() => {
      setMessage({ type: "", text: "" });
    }, 5000);
  };

  // Handle export data
  const handleExportData = () => {
    setExportLoading(true);
    
    // Simulate data export process
    setTimeout(() => {
      setExportLoading(false);
      setMessage({
        type: "success",
        text: `${exportType === 'all' ? 'All data' : exportType} exported successfully! Check your email.`
      });
      
      // Auto-clear message after 5 seconds
      setTimeout(() => {
        setMessage({ type: "", text: "" });
      }, 5000);
    }, 2000);
  };

  return (
    <div className="privacy-settings">
      <div className="settings-section">
        <h3>Privacy Settings</h3>
        <p className="section-description">
          Control who can see your profile and activity.
        </p>
        
        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="publicProfile"
              checked={privacySettings.publicProfile}
              onChange={handlePrivacyChange}
            />
            <span>Public Profile</span>
          </label>
          <small>
            Allow other users to view your profile information
          </small>
        </div>

        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="showActivity"
              checked={privacySettings.showActivity}
              onChange={handlePrivacyChange}
            />
            <span>Show Activity</span>
          </label>
          <small>
            Display your recent activity on your profile page
          </small>
        </div>

        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              name="showLists"
              checked={privacySettings.showLists}
              onChange={handlePrivacyChange}
            />
            <span>Public Lists</span>
          </label>
          <small>
            Make your anime and manga lists visible to other users
          </small>
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="save-settings-btn"
            onClick={handleSavePrivacySettings}
          >
            Save Privacy Settings
          </button>
        </div>
      </div>

      <div className="settings-section">
        <h3>Data Export</h3>
        <p className="section-description">
          Export a copy of your data for personal backup or to use on another platform.
        </p>

        <div className="form-group">
          <label htmlFor="exportType">Select data to export</label>
          <select
            id="exportType"
            value={exportType}
            onChange={(e) => setExportType(e.target.value)}
          >
            <option value="all">All my data</option>
            <option value="anime">Anime lists only</option>
            <option value="manga">Manga lists only</option>
            <option value="reviews">Reviews only</option>
          </select>
        </div>

        <div className="export-actions">
          <button
            type="button"
            className="export-btn"
            onClick={handleExportData}
            disabled={exportLoading}
          >
            {exportLoading ? (
              <>
                <span className="loading-spinner-small"></span>
                Preparing Export...
              </>
            ) : (
              "Export Data"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacySettings;